module.exports = __webpack_public_path__ + "static/media/realtime.a0ef1ec2.png";